<template>
    <list-page icone="mdi-chart-line-variant" titulo="Atividade (Monitoramento)" @novo="Novo()" @atualizar="Carregar()" :temBuscaRapida="true" :buscaRapida.sync="search" >
        <template v-slot:corpo>

          <v-data-table id="tabela" :headers="headers" :items="lista" :options.sync="options" :server-items-length="totalLista" :loading="loading" class="elevation-1">
            
            <template v-slot:[`item.actions`]="{ item }">

              <v-tooltip right>
                <template v-slot:activator="{ on }">
                  <v-icon small @click="Editar(item)" v-on="on">mdi-pencil</v-icon>
                </template>
                <span>Editar</span>
              </v-tooltip>

              <v-tooltip right>
                <template v-slot:activator="{ on }">
                  <v-icon small @click="Excluir(item)" v-on="on">mdi-delete</v-icon>
                </template>
                <span>Excluir</span>
              </v-tooltip>

            </template>

            <template v-slot:[`item.data`]="{ item }">
              {{new Date(item.data).ddmmyyyy()}}
            </template>

          </v-data-table>

          <!-- <v-data-table :headers="headers" :items="lista" :options.sync="options" :server-items-length="totalLista" :loading="loading" class="elevation-1">
            <template v-slot:body="{ items }">
              <tbody>
                <tr v-for="item in items" :key="item.id">
                    <td class="justify-center layout px-0">
                      <v-tooltip right>
                        <template v-slot:activator="{ on }">
                          <v-icon small @click="Editar(item)" v-on="on">mdi-pencil</v-icon>
                        </template>
                        <span>Editar</span>
                      </v-tooltip>
                      <v-tooltip right>
                        <template v-slot:activator="{ on }">
                          <v-icon small @click="Excluir(item)" v-on="on">mdi-delete</v-icon>
                        </template>
                        <span>Excluir</span>
                      </v-tooltip>
                    </td>
                    <td>{{ item.projeto.codigoNome }}</td>
                    <td>{{ new Date(item.data).ddmmyyyy() }}</td>
                    <td>{{ item.avaliacao }}</td>
                </tr>
              </tbody>
            </template>
          </v-data-table> -->

          <v-overlay :value="primeiraCarga">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
          </v-overlay>

          <cadastro-monitoramento-atividade v-model="dialogCadastro" :item="item" @fechou="dialogCadastro = false" @salvou="Carregar()"/>
          
        </template>
    </list-page>
</template>

<script>

import MonitoramentoAtividadeService from '@/core/services/projetos/monitoramento/MonitoramentoAtividadeService';
import MonitoramentoAtividade from '@/core/domain/projetos/monitoramento/MonitoramentoAtividade';
import ListPage from "@/components/shared/ListPage";

export default {
  extends: ListPage,
    watch: { 
      item: function() { 
        if ('formAtividade' in this.$refs)
          this.$refs.formAtividade.resetValidation();        
      },
      lista: function(){
        if(this.primeiraCarga)
          this.primeiraCarga = false;
      }
    },
    data: () => ({
      headers: [
        { text: '', value: 'actions', sortable: false},
        { text: 'Projeto', value: 'projeto.nome' },
        { text: 'Data', value: 'data', type:'date' },
        { text: 'Avaliação', value: 'avaliacao' },
      ],
      primeiraCarga: true
    }),
    created() {
      this.service = new MonitoramentoAtividadeService();
    },
    methods: {
      Novo(){
        this.NovoCadastro(new MonitoramentoAtividade());
      },
      Editar(item){
        this.service.ObterPorId(item.id, "Itens.Atividade, Itens.AtividadeItem, Projeto.Atividades").then(
          res =>{
            this.EditarCadastro(new MonitoramentoAtividade(res.data));
          },
          err => this.$swal('Aviso', err.response.data, 'error')
        )
      },
      Carregar(){
        this.include = "Projeto"
        this.Listar(null, "Projeto")
      }
    },
    mounted() {
      this.Carregar()
    }
}

</script>